import React, { createContext } from 'react';
import { DexDispatcherFormEnumType } from '@mark43/cad-api';

export const DexFormNameContext = createContext<DexDispatcherFormEnumType | undefined>(undefined);

export function DexFormNameProvider(props: {
    name: DexDispatcherFormEnumType;
    children: React.ReactNode;
}) {
    return (
        <DexFormNameContext.Provider value={props.name}>
            {props.children}
        </DexFormNameContext.Provider>
    );
}

export function useDexFormName(): DexDispatcherFormEnumType | undefined {
    return React.useContext(DexFormNameContext);
}
